var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner3",class:_vm.type},[_c('p',[_vm._v(_vm._s(_vm.text))]),(_vm.closable)?_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Cerrar"},on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("X")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }